// extracted by mini-css-extract-plugin
export var banner = "_1-0";
export var icon = "_1-1";
export var message = "_1-2";